import { GetCartTransformResponseBodyType } from "@intelligems/ig-types";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api";
import { useGetOrg } from "../organizations/get-organization";
import { organizationsKeys } from "../queryKeys";

const getCartTransforms = async () => {
  const resp = await api.get<GetCartTransformResponseBodyType>(
    `/v2/shops/cart-transforms`
  );
  return resp.data;
};
export const useGetCartTransforms = () => {
  const org = useGetOrg();

  return useQuery<GetCartTransformResponseBodyType, Error>({
    queryKey: organizationsKeys.cartTransforms(org.data.org.id),
    queryFn: async () => getCartTransforms(),
    enabled: !!org.data.org.id,
  });
};
